module.exports = __webpack_public_path__ + "static/media/Amealio_Illustrations-03.20480a4d.svg";